import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import CardDashboardTemplate from "@/pages/DashboardPage/components/templates/CardDashboardTemplate"
import { useSensorsCount } from "@/pages/DeploymentsPage/application/useDeployments"
import { EmptyStateWidget } from "./EmptyStateWidget"
import { EnvironmentDropdown } from "./EnvironmentDropdown"
import { SensorUsageGraph } from "./SensorUsageGraph"
import { StatisticWidget } from "./StatisticWidget"
import { WidgetTemplate } from "./WidgetTemplate"

import styles from "./HeaderDeploymentsTab.module.scss"

export const SensorUsageWidget = () => {
  const { t } = useTranslation()
  const { t: tWidgets } = useTranslation("translation", {
    keyPrefix: "deployments.widgets"
  })
  const { intlNumber } = useNumberConvertor()
  const [{ response, isLoading }, state] = useSensorsCount()
  const { highestPeakLiveCount = 0 } = response || {}
  const noUsageData = highestPeakLiveCount === 0 && !isLoading

  return (
    <CardDashboardTemplate
      loading={isLoading}
      className={{ card: styles.card }}
      title={
        <Heading
          level={5}
          title={tWidgets("usage.title")}
          popover={{
            content: tWidgets("usage.popover")
          }}
        />
      }
      aside={<EnvironmentDropdown state={state} />}
    >
      <EmptyStateWidget noUsageData={noUsageData}>
        <WidgetTemplate componentProps={response} Component={SensorUsageGraph}>
          {highestPeakLiveCount > 0 && (
            <StatisticWidget
              title={tWidgets("usage.highest")}
              value={intlNumber(highestPeakLiveCount)}
              suffix={capitalizeFirstLetter(
                t("general.sensor", { count: highestPeakLiveCount })
              )}
            />
          )}
        </WidgetTemplate>
      </EmptyStateWidget>
    </CardDashboardTemplate>
  )
}
